import HelperGeneral from "../../helpers/HelperGeneral";
import {setUserInfo} from "../../services/redux/actions/UserAction";
import Api from "../../services/Api";
import {notification} from "antd";

const UserInfo = {
    setUserInfo: function (userInfo, remember = true) {
        if (remember) {
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
        }

        // else {
        //     sessionStorage.setItem('userInfo', JSON.stringify(userInfo));
        // }
        setUserInfo(userInfo);
    },
    globalCheck: function () {
        return new Promise((resolve, reject) => {
            const {userInfo, remember} = UserInfo.dataCheck();
            if (userInfo && userInfo?.id) {
                Api.getCustomer().then(r => {
                    UserInfo.setUserInfo(r?.data, remember);
                    resolve(true);
                }).catch((e) => {
                    reject(e);
                });
            } else {
                resolve(true);
            }
        });
    },
    dataCheck: function () {
        let remember = true;
        let userInfo = localStorage.getItem('userInfo');
        userInfo = userInfo ? JSON.parse(userInfo) : false;
        // if (userInfo && userInfo?.id) {
        //     remember = true;
        // }
        return {remember, userInfo};
    },
    info: function (attr) {
        const {userInfo} = UserInfo.dataCheck();
        if (userInfo && userInfo?.id) {
            if (attr) {
                const json2array = HelperGeneral.json2array(userInfo);
                if (json2array[attr]) {
                    return json2array[attr];
                }
                return null;
            }
            return userInfo;
        }
        return null;
    },
    set: function (name, value) {
        let userInfo = localStorage.getItem('userInfo');
        if (userInfo) {
            userInfo = JSON.parse(userInfo);
            if (name && HelperGeneral.getObjectKeyExists(userInfo, value)) {
                userInfo[name] = value;
                localStorage.setItem('userInfo', JSON.stringify(userInfo));
                return userInfo[name];
            }
        }
        return false;
    },
    logout: (self) => {
        try {
            if (typeof window.soulTrackEvent === 'function') {
                window.soulTrackEvent({
                    eventName: 'logout',
                    type: 'logout',
                    logout_type: 'success',
                });
            }
        } catch (e) {
            // best-effort
        }
        localStorage.removeItem('userInfo');
        localStorage.removeItem('userToken');
        localStorage.removeItem('basketList');
        localStorage.removeItem('consumerLastLookedItems');
        localStorage.removeItem('pharmacyLastLookedItems');
        localStorage.removeItem('priceListInfo');
        HelperGeneral.pageChange(self, '/login');
        notification['success']({
            message: 'Başarılı!',
            description: 'Güvenli çıkış işlemi başarıyla gerçekleşti',
        });
    },
    logout2: () => {
        localStorage.removeItem('userInfo');
        localStorage.removeItem('userToken');
        localStorage.removeItem('basketList');
        localStorage.removeItem('consumerLastLookedItems');
        localStorage.removeItem('pharmacyLastLookedItems');
        localStorage.removeItem('priceListInfo');
    },
    isLogin: function () {
        let userInfo = localStorage.getItem('userToken');
        userInfo = JSON.parse(userInfo);
        return !!userInfo;
    },
    profileImage: function (img) {
        const default_image = require('../../assets/images/png/avatar.jpeg');
        let profileImage = img ? img : UserInfo.info('profile');
        if (profileImage) {
            return profileImage;
        }
        return default_image;
    },
    fullUserName: function () {
        return UserInfo.info('first_name') + ' ' + UserInfo.info('last_name');
    },
    shortName: function () {
        const d = UserInfo.info('first_name');
        const l = UserInfo.info('last_name');
        return (d ? d[0] : '') + (l ? l[0] : '');
    },
    brandInfo: function () {
        let brandInfo = localStorage.getItem('brandInfo');
        return brandInfo ? JSON.parse(brandInfo) : false;
    }
};
export default UserInfo;
